import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/booking/new-booking-container/NewBookingContainer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/translation-provider.tsx")